export default "__VITE_ASSET__ChuXM6sf__"